import * as React from 'react';
import cx from 'classnames';
import { CnIcon } from '@/components/cn-icon';
import './index.scss';
export const CnButton = (props) => {
    const { children, onClick, className, component, type, text, inverse, fullWidth, htmlType, loading, disabled, size, warning, href, target, ...others } = props;
    const fill = React.useMemo(() => {
        if (text) {
            return 'none';
        }
        if (type === 'primary') {
            return 'solid';
        }
        return 'outline';
    }, [type, text]);
    const color = React.useMemo(() => {
        if (inverse) {
            return 'inverse';
        }
        if (warning) {
            return 'warning';
        }
        if (type === 'primary' || (type === 'secondary' && !text)) {
            return 'primary';
        }
        return 'default';
    }, [warning, text, type, inverse]);
    const classes = cx(className, {
        'cn-ui-m-button': true,
        [`cn-ui-m-button-${color}`]: !!color,
        [`cn-ui-m-button-fill-${fill}`]: !!fill,
        [`cn-ui-m-button-${size}`]: !!size,
        'cn-ui-m-button-loading': !!loading,
        'cn-ui-m-button-disabled': !!disabled,
        'cn-ui-m-button-fullwidth': !!fullWidth,
    });
    const TagName = component;
    const tagAttrs = {};
    if (TagName === 'button') {
        tagAttrs.type = htmlType;
    }
    else if (TagName === 'a') {
        tagAttrs.href = href;
        tagAttrs.target = target;
    }
    return (React.createElement(TagName, { ...others, ...tagAttrs, onClick: onClick, disabled: disabled, className: classes },
        loading ? (React.createElement(CnIcon, { className: "cn-ui-m-button-loading-icon", type: "progressing", style: { display: 'block' } })) : null,
        children));
};
CnButton.displayName = 'CnButton';
CnButton.defaultProps = {
    type: 'normal',
    size: 'medium',
    fullWidth: false,
    component: 'button',
    htmlType: 'button',
    loading: false,
    warning: false,
    text: false,
    inverse: false,
    disabled: false,
};
